module.exports = __webpack_public_path__ + "img/6.5c9a179f.png";